import { z } from 'zod';

import { workspaceSummarySchema } from './workspace.js';

/**
 * Who the caller is - AUTH-009.
 *
 * `GET /v1/me` is the first call the SPA makes after a login and the only one
 * that answers "does this token belong to somebody we know". It carries the
 * caller's workspaces because the alternative is a second round trip before the
 * app can render anything at all.
 *
 * The subject claim is deliberately absent. The client already holds it inside
 * its own token, and echoing an identity-provider identifier back into a
 * response body only widens where it can be logged.
 */
export const meResponseSchema = z
  .object({
    user: z
      .object({
        id: z.uuid(),
        email: z.string(),
        displayName: z.string(),
        createdAt: z.string(),
      })
      .readonly(),
    workspaces: z.array(workspaceSummarySchema).readonly(),
  })
  .readonly();

export type MeResponse = z.infer<typeof meResponseSchema>;
